<template>
  <common-page title="重置密码">
    <el-steps :active="stepActive" simple finish-status="success">
      <el-step title="填写新密码"/>
      <el-step title="完成重置"/>
    </el-steps>
    <el-form v-if="stepActive===0" ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="手机号码" prop="regPhone">
        <el-input v-model="form.regPhone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item prop="verifyCode" label="验证码">
        <div class="forget-msg-yzm">
          <el-input
            v-model="form.verifyCode"
            auto-complete="off"
            placeholder="验证码"
            prefix-icon="el-icon-lollipop"
          >
          </el-input>
          <img :src="codeUrl" @click="getCode"/>
        </div>
      </el-form-item>
      <el-form-item label="短信验证码" prop="yzm" style="margin-bottom: 35px;">
        <div class="forget-msg-yzm">
          <el-input v-model="form.yzm" prefix-icon="el-icon-unlock" clearable
                    :placeholder="$t('login.smsPlaceholder')"></el-input>
          <el-button @click="getYzm" :disabled="disabled">{{ this.$t('login.smsGet') }}<span
            v-if="disabled"> ({{ time }})</span></el-button>
        </div>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" show-password placeholder="请输入新密码"></el-input>
        <div class="el-form-item-msg">请输入包含英文、数字的8位以上密码</div>
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" show-password placeholder="请再一次输入新密码"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="save">提交</el-button>
      </el-form-item>
    </el-form>
    <el-result v-if="stepActive===1" icon="success" title="密码重置成功"
               sub-title="请牢记自己的新密码,返回登录后使用新密码登录">
      <template #extra>
        <el-button type="primary" @click="backLogin">返回登录</el-button>
      </template>
    </el-result>
  </common-page>
</template>

<script>
import commonPage from './components/commonPage'
import UserApi from '@/api/user.js';

export default {
  components: {
    commonPage
  },
  data() {
    return {
      codeUrl: "",
      stepActive: 0,
      form: {
        regPhone: "",
        yzm: "",
        password: "",
        confirmPassword: ""
      },
      rules: {
        regPhone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        yzm: [
          {required: true, message: '请输入短信验证码'}
        ],
        password: [
          {required: true, message: '请输入新的密码'}
        ],
        verifyCode: [
          {required: true, message: '请输入验证码'}
        ],
        confirmPassword: [
          {required: true, message: '请再次输入新的密码'},
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }
          }
        ],
      },
      disabled: false,
      time: 0
    }
  },
  mounted() {
    this.getCode();
  },
  methods: {
    getCode() {
      let self = this;
      UserApi.getCodeImg({width: 130, height: 40})
        .then(res => {
          self.codeUrl = res.data.base64;
          self.form.verifyKey = res.data.key;
        });
    },
    /**
     * 校验多个字段
     */
    async validateFields() {
      let self = this;
      // 需要校验的字段
      let fieldsToValidate = ['regPhone', 'verifyCode'];
      // 将回调转换为Promise
      return await Promise.all(
        fieldsToValidate.map((field) => {
          return new Promise((resolve, reject) => {
            self.$refs.form.validateField(field, (errorMessage) => {
              resolve(errorMessage);
            });
          });
        })
      ).then((errorMessages) => {
        // 判断errorMessages 里是否全是空串
        return errorMessages.every((errorMessage) => {
          return errorMessage === '';
        });
      });
    },
    async getYzm() {
      let self = this;
      const validate = await self.validateFields();
      if (!validate) {
        return false
      }
      const validatePhone = await self.checkExistName();
      if (!validatePhone) {
        return false
      }

      let Params = {
        telephone: self.form.regPhone,
        verifyCode: self.form.verifyCode,
        verifyKey: self.form.verifyKey,
      };
      UserApi.getCodeSms(Params)
        .then(res => {
          self.$message.success(this.$t('login.smsSent'))
          self.disabled = true
        })
        .catch(error => {
          self.disabled = true
        });

      self.time = 60
      let t = setInterval(() => {
        self.time -= 1
        if (self.time < 1) {
          clearInterval(t)
          self.disabled = false
          self.time = 0
        }
      }, 1000)
    },
    async save() {
      let self = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let Params = {
            ...self.form
          };
          Params.verifyCode = self.form.yzm;
          Params.verifyKey = self.form.regPhone;

          UserApi.resetPassword(Params)
            .then(res => {
              self.stepActive += 1
            })
            .catch(error => {
            });
        } else {
          return false
        }
      })
    },
    async checkExistName() {
      let self = this;
      let Params = {
        userName: self.form.regPhone,
      };
      return await new Promise((resolve, reject) => {
        UserApi.checkExistName(Params)
          .then(res => {
            if (res.data === true) {
              resolve(true)
            } else {
              self.$message.error(this.$t('login.regPhoneNotExist'))
              reject()
            }
          })
          .catch(error => {
            reject()
          });
      })
    },
    backLogin() {
      this.$router.push({
        path: '/login'
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.forget-msg-yzm {
  display: flex;
  width: 100%;

  .el-button {
    margin-left: 10px;
    --el-button-size: 42px;
  }

  img {
    width: 100px;
    height: 35px;
    cursor: pointer;
    vertical-align: middle;
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/login/forget.vue